<template>
  <div class="w-100 fill">
    <b-container fluid>
      <b-row class="fill justify-between">
        <b-col
          cols="4"
          class="pt-4 fill overflow-y-scroll shadow bg-white"
        >
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
          >
            <rs-repository-tree
              v-for="repository in getRepositories" :key="repository.repositorioId"
              class="item"
              :repository="repository"
            />
          </transition>
        </b-col>
        <b-col md="8" class="h-100 flex flex-col">
          <div class="nav-panel">
            <rs-navigation-panel
              :add-file="addFile"
              :toggle="toggle"
              :files="files"
              :show-principal-button="showPrincipalButton"
              :max-files="maxFiles"
              :required-file-type="requiredFileType"
              :accepted-file-extensions="acceptedFileExtensions"
              :required-approval-state="requiredApprovalState"
            />
          </div>
          <div class="selected-docs-panel">
            <b-row>
              <b-col cols="12">
                <h4 class="text-primary m-0 p-2">
                  Documentos seleccionados {{ files.length + '/' + maxFiles }}
                </h4>
              </b-col>
              <b-col cols="3" v-for="file in files" :key="file.id" class="text-center mb-3">
                <div class="d-flex flex-column align-items-center">
                  <vs-icon icon="description" size="25px" color="primary" />
                  <b class="text-truncate w-100 mt-2">{{ file.name }}</b>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import RsNavigationPanel from '@/febos/global/customDocuments/components/repository-selector/RSNavigationPanel';
import RsRepositoryTree from '@/febos/global/customDocuments/components/repository-selector/RSRepositoryTree';

export default {
  name: 'rs-document-manager',
  components: {
    RsNavigationPanel,
    RsRepositoryTree,
  },
  data() {
    return {
      detailItem: {},
      toggle: false
    };
  },
  props: {
    showPrincipalButton: {
      type: Boolean,
      default: false
    },
    addFile: {
      type: Function
    },
    removeFile: {
      type: Function
    },
    files: {
      type: Array,
      default: () => []
    },
    maxFiles: {
      type: Number,
      required: true
    },
    requiredFileType: String,
    acceptedFileExtensions: String,
    requiredApprovalState: Number,
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getRepositories',
      'getSelectedElement',
      'loading'
    ])
  },
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('List', [
      'fetchUserGroups'
    ]),
    ...mapActions('DocManagement', [
      'loadRepositories',
      'cleanTreeView',
      'setSelectedRepository'
    ]),
    toggleView() {
      console.log('toggle from parent');
      this.toggle = !this.toggle;
    },
  },
  beforeMount() {
    this.cleanTreeView();
  },
  mounted() {
    if (window.location.hash !== '') {
      this.$bvToast.toast(
        'Espera unos segundos mientras vamos hacia tu archivo o carpeta',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 15000
        }
      );
    }
    this.loadRepositories();
  },
  created() {
    this.closeModal();
  }
};
</script>

<style lang="scss" scoped>
@import '~animate.css/animate.compat.css';
.fill {
  height: calc(var(--vh, 1vh) * 100 - 12.5rem);
}
.tree-panel {
  height: calc(var(--vh, 1vh) * 100 - 14.5rem);
}
</style>
<style>
.nav-panel {
  height: 70%;
  max-height: 70%;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
.selected-docs-panel {
  height: 30%;
  overflow-y: auto;
}
</style>
